var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "con-btn" }, [
    _c(
      "div",
      { staticClass: "breadcrumb-layout" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
              _vm._v("首页")
            ]),
            _vm._v(" "),
            _c("el-breadcrumb-item", [_vm._v("发货单")])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "block-container" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form-single mt20 mb20" }, [
          _c("div", { staticClass: "title required" }, [_vm._v("配货单")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              { staticClass: "pos-rel", staticStyle: { width: "640px" } },
              [
                _c("el-input", {
                  staticClass: "bottom-line width-4x",
                  staticStyle: { width: "100%" },
                  attrs: { disabled: true },
                  model: {
                    value: _vm.shipVoucher.allocFormTitle,
                    callback: function($$v) {
                      _vm.$set(_vm.shipVoucher, "allocFormTitle", $$v)
                    },
                    expression: "shipVoucher.allocFormTitle"
                  }
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass:
                    "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                  on: {
                    click: function($event) {
                      _vm.selectAllocForm()
                    }
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single mt20 mb20" }, [
          _c("div", { staticClass: "title" }, [_vm._v("客户名称")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("el-input", {
                staticClass: "bottom-line width-4x",
                attrs: { disabled: true },
                model: {
                  value: _vm.shipVoucher.buyerName,
                  callback: function($$v) {
                    _vm.$set(_vm.shipVoucher, "buyerName", $$v)
                  },
                  expression: "shipVoucher.buyerName"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single mt20 mb20" }, [
          _c("div", { staticClass: "title" }, [_vm._v("业务单元")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("el-input", {
                staticClass: "bottom-line width-4x",
                attrs: { disabled: true },
                model: {
                  value: _vm.shipVoucher.buyerShopName,
                  callback: function($$v) {
                    _vm.$set(_vm.shipVoucher, "buyerShopName", $$v)
                  },
                  expression: "shipVoucher.buyerShopName"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single mt20 mb20" }, [
          _c("div", { staticClass: "title" }, [_vm._v("所属部门")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("el-input", {
                staticClass: "bottom-line width-4x",
                attrs: { disabled: true },
                model: {
                  value: _vm.shipVoucher.buyerBizUnitName,
                  callback: function($$v) {
                    _vm.$set(_vm.shipVoucher, "buyerBizUnitName", $$v)
                  },
                  expression: "shipVoucher.buyerBizUnitName"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single mt20 mb20" }, [
          _c("div", { staticClass: "title" }, [_vm._v("收货地址")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("el-input", {
                staticClass: "bottom-line width-4x",
                attrs: { disabled: true },
                model: {
                  value: _vm.shipVoucher.buyerRecvAddr,
                  callback: function($$v) {
                    _vm.$set(_vm.shipVoucher, "buyerRecvAddr", $$v)
                  },
                  expression: "shipVoucher.buyerRecvAddr"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single mt20 mb20" }, [
          _c("div", { staticClass: "title" }, [_vm._v("收货人")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("el-input", {
                staticClass: "bottom-line  width-4x",
                attrs: { disabled: true },
                model: {
                  value: _vm.shipVoucher.buyerRecvContractName,
                  callback: function($$v) {
                    _vm.$set(_vm.shipVoucher, "buyerRecvContractName", $$v)
                  },
                  expression: "shipVoucher.buyerRecvContractName"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single mt20 mb20" }, [
          _c("div", { staticClass: "title" }, [_vm._v("联系电话")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("el-input", {
                staticClass: "bottom-line  width-4x",
                attrs: { disabled: true },
                model: {
                  value: _vm.shipVoucher.buyerRecvContactTel,
                  callback: function($$v) {
                    _vm.$set(_vm.shipVoucher, "buyerRecvContactTel", $$v)
                  },
                  expression: "shipVoucher.buyerRecvContactTel"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("el-form", { attrs: { rules: _vm.validateRules } }, [
          _c(
            "div",
            {
              staticClass: "form-single",
              staticStyle: { overflow: "visible", "margin-bottom": "15px" }
            },
            [
              _c("div", { staticClass: "title required" }, [_vm._v("发货人")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mr20",
                      attrs: { prop: "senderContactName" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "width-1-5x",
                        model: {
                          value: _vm.shipVoucher.senderContactName,
                          callback: function($$v) {
                            _vm.$set(_vm.shipVoucher, "senderContactName", $$v)
                          },
                          expression: "shipVoucher.senderContactName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-single",
              staticStyle: { overflow: "visible", "margin-bottom": "15px" }
            },
            [
              _c("div", { staticClass: "title required" }, [
                _vm._v("发货人联系方式")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mr20",
                      attrs: { prop: "senderContactTel" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "width-1-5x",
                        model: {
                          value: _vm.shipVoucher.senderContactTel,
                          callback: function($$v) {
                            _vm.$set(_vm.shipVoucher, "senderContactTel", $$v)
                          },
                          expression: "shipVoucher.senderContactTel"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-single",
              staticStyle: { overflow: "visible", "margin-bottom": "15px" }
            },
            [
              _c("div", { staticClass: "title" }, [_vm._v("要求到货日期")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("span", [_vm._v(_vm._s(_vm.desireArriveDate || "无"))])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-single",
              staticStyle: { overflow: "visible", "margin-bottom": "15px" }
            },
            [
              _c("div", { staticClass: "title required" }, [
                _vm._v("预计到货日期")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mr20",
                      attrs: { prop: "expectArriveDate" }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "picker-options": _vm.pickerOptions0,
                          type: "date",
                          placeholder: "选择日期"
                        },
                        model: {
                          value: _vm.shipVoucher.expectArriveDate,
                          callback: function($$v) {
                            _vm.$set(_vm.shipVoucher, "expectArriveDate", $$v)
                          },
                          expression: "shipVoucher.expectArriveDate "
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single mt20 mb20" }, [
          _c("div", { staticClass: "title" }, [_vm._v("公司名称")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              { staticClass: "pos-rel", staticStyle: { width: "640px" } },
              [
                _c("el-input", {
                  staticClass: "bottom-line width-4x",
                  staticStyle: { width: "100%" },
                  attrs: { disabled: true },
                  model: {
                    value: _vm.shipVoucher.logisComName,
                    callback: function($$v) {
                      _vm.$set(_vm.shipVoucher, "logisComName", $$v)
                    },
                    expression: "shipVoucher.logisComName"
                  }
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass:
                    "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                  on: {
                    click: function($event) {
                      _vm.showLogisCom()
                    }
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single mt20 mb20" }, [
          _c("div", { staticClass: "title" }, [_vm._v("公司代码")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              { staticClass: "pos-rel", staticStyle: { width: "600px" } },
              [
                _c("el-input", {
                  staticClass: "bottom-line width-4x",
                  staticStyle: { width: "100%" },
                  attrs: { disabled: true },
                  model: {
                    value: _vm.shipVoucher.logisComCode,
                    callback: function($$v) {
                      _vm.$set(_vm.shipVoucher, "logisComCode", $$v)
                    },
                    expression: "shipVoucher.logisComCode"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "el-form",
          { ref: "logisExpNo", attrs: { rules: _vm.logisExpNoRules } },
          [
            _c(
              "div",
              {
                staticClass: "form-single mt20 mb20",
                staticStyle: { overflow: "visible", "margin-bottom": "15px" }
              },
              [
                _c("div", { staticClass: "title" }, [_vm._v("物流单号")]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c(
                    "div",
                    { staticClass: "pos-rel", staticStyle: { width: "600px" } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "pr20", attrs: { prop: "logisExpNo" } },
                        [
                          _c("el-input", {
                            staticClass: "bottom-line width-4x",
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入物流单号" },
                            model: {
                              value: _vm.shipVoucher.logisExpNo,
                              callback: function($$v) {
                                _vm.$set(_vm.shipVoucher, "logisExpNo", $$v)
                              },
                              expression: "shipVoucher.logisExpNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-single mt20 mb20",
                staticStyle: { overflow: "visible", "margin-bottom": "15px" }
              },
              [
                _c("div", { staticClass: "title" }, [_vm._v("物流费用(元)")]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c(
                    "div",
                    { staticClass: "pos-rel", staticStyle: { width: "600px" } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "pr20", attrs: { prop: "logisFee" } },
                        [
                          _c("el-input", {
                            staticClass: "bottom-line width-4x",
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "text",
                              placeholder: "请输入物流费用"
                            },
                            model: {
                              value: _vm.shipVoucher.logisFee,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.shipVoucher,
                                  "logisFee",
                                  _vm._n($$v)
                                )
                              },
                              expression: "shipVoucher.logisFee"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-layout" },
          [
            _c(
              "el-form",
              { ref: "shipVoucher", attrs: { model: _vm.shipVoucher } },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.shipVoucher.itemList, border: "" }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "200",
                        prop: "title",
                        label: "商品名称"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "150",
                        prop: "catName",
                        label: "分类名称"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "150",
                        prop: "brandName",
                        label: "品牌名称"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "100",
                        prop: "vendorUknoFlag",
                        label: "提供商品标识码"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: rows.row.vendorUknoFlag,
                                    expression: "rows.row.vendorUknoFlag"
                                  }
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    rows.row.vendorUknoFlag
                                  )
                                    ? _vm._i(rows.row.vendorUknoFlag, null) > -1
                                    : rows.row.vendorUknoFlag
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = rows.row.vendorUknoFlag,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            rows.row,
                                            "vendorUknoFlag",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            rows.row,
                                            "vendorUknoFlag",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(rows.row, "vendorUknoFlag", $$c)
                                    }
                                  }
                                }
                              })
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "100",
                        prop: "price",
                        label: "含税价(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.price != null
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.price.toFixed(2)))
                                  ])
                                : _c("span", [_vm._v("0.00")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "100",
                        prop: "taxRate",
                        label: "税率(%)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.ntxPrice != null
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.taxRate || 0))
                                  ])
                                : _c("span", [_vm._v("0")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        width: "100",
                        prop: "ntxPrice",
                        label: "未税价(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.ntxPrice != null
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.ntxPrice.toFixed(2)))
                                  ])
                                : _c("span", [_vm._v("0.00")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "150",
                        prop: "amount",
                        label: "费用小计(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.price != null &&
                              rows.row.quantity != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(rows.row.price * rows.row.quantity)
                                    )
                                  ])
                                : _c("span", [_vm._v("0.00")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "150",
                        prop: "ntxAmount",
                        label: "未税小计(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.price != null && rows.row.taxRate != null
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        (
                                          rows.row.price /
                                          (1 + rows.row.taxRate * 0.01)
                                        ).toFixed(2) * rows.row.quantity
                                      )
                                    )
                                  ])
                                : _c("span", [_vm._v("0.00")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      staticClass: "required",
                      attrs: {
                        align: "right",
                        width: "100",
                        prop: "wrntPeriod",
                        label: "质保期(月)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.orderFlag
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.wrntPeriod || 0))
                                  ])
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.wrntPeriod,
                                        expression: "rows.row.wrntPeriod"
                                      }
                                    ],
                                    staticClass: "align-right",
                                    staticStyle: { width: "100%" },
                                    attrs: { type: "number", min: 0 },
                                    domProps: { value: rows.row.wrntPeriod },
                                    on: {
                                      change: function($event) {
                                        _vm.wrntPeriodChange(rows.row)
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "wrntPeriod",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        width: "100",
                        prop: "quantity",
                        label: "配货数量"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        width: "100",
                        prop: "quantity",
                        label: "发货数量"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "80",
                        prop: "unit",
                        label: "单位"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "200",
                        prop: "desc",
                        label: "说明"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-toolbar" }, [
      _c(
        "button",
        {
          staticClass: "swb-btn swb-btn-small swb-btn-primary",
          on: { click: _vm.goBack }
        },
        [_vm._v("取消")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "swb-btn swb-btn-small",
          on: { click: _vm.saveShipVoucher }
        },
        [_vm._v("发货")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("配货信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("物流信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("商品信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d11b0af6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d11b0af6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsShipVoucherAdd.vue
// module id = 1830
// module chunks = 1